/* app/data.jsx - Marketlens IA + sample data. Exposed on window. */
(function () {
  // Exact nav groups + order from the brief. icon = MlIcon/DS name.
  const NAV_GROUPS = [
    { label: "Content", items: [
      { id: "posts", label: "Posts", icon: "file-text" },
      { id: "pages", label: "Pages", icon: "file" },
      { id: "categories", label: "Categories", icon: "folder" },
      { id: "tags", label: "Tags", icon: "tag" },
      { id: "taxonomy-suggestions", label: "Taxonomy Library", icon: "sparkles" },
      { id: "taxonomy-audit", label: "Taxonomy Audit", icon: "shield-check" },
    ]},
    { label: "Reports", items: [
      { id: "reports", label: "Reports", icon: "bar-chart" },
    ]},
    { label: "SEO & Performance", items: [
      { id: "seo-dashboard", label: "SEO Dashboard", icon: "gauge" },
      { id: "performance", label: "Performance", icon: "trending-up" },
      { id: "site-audit", label: "Site Audit", icon: "shield-check" },
      // Crawl-only sites only: main.jsx drops this entry on a site that has a
      // CMS, because such a site's pages come out of the CMS under Pages and
      // the crawl API would simply answer NOT_CRAWL_SITE.
      { id: "page-inventory", label: "Page Inventory", icon: "list" },
      { id: "bulk-meta", label: "Bulk Meta Editor", icon: "edit" },
      { id: "internal-linking", label: "Internal Linking", icon: "link" },
    ]},
    { label: "Research", items: [
      { id: "content-planner", label: "Content Planner", icon: "calendar-days" },
      { id: "keywords-planner", label: "Keywords Planner", icon: "target" },
      { id: "topics-bank", label: "Topics Bank", icon: "layers" },
      { id: "coverage-map", label: "Coverage Map", icon: "compass" },
      { id: "industry-analysis", label: "Industry Analysis", icon: "building" },
      { id: "competitors-analysis", label: "Competitors Analysis", icon: "users" },
      { id: "partners-analysis", label: "Partners Analysis", icon: "puzzle" },
      { id: "product-enrichment", label: "Product Enrichment", icon: "sparkles" },
    ]},
    { label: "Pipeline", items: [
      { id: "inbox", label: "Inbox", icon: "inbox" },
      { id: "todo", label: "To-do", icon: "check-square" },
    ]},
    { label: "Business Intelligence", items: [
      { id: "business-profile", label: "Business Profile", icon: "briefcase" },
      { id: "products", label: "Products", icon: "box" },
      { id: "bi-competitors", label: "Competitors", icon: "flag" },
      { id: "bi-industry", label: "Industry", icon: "globe" },
      { id: "bi-partners", label: "Partners", icon: "git-branch" },
    ]},
    { label: "Site", items: [
      { id: "ai-assistant", label: "AI Assistant", icon: "message-circle" },
    ]},
  ];

  // The WordPress network's country editions (active site switcher).
  const SITES = [
    { id: "us", name: "Marketlens US",  url: "marketlens.com",      flag: "🇺🇸", lang: "English (US)" },
    { id: "uk", name: "Marketlens UK",  url: "marketlens.co.uk",    flag: "🇬🇧", lang: "English (UK)" },
    { id: "de", name: "Marketlens DE",  url: "marketlens.de",       flag: "🇩🇪", lang: "German" },
    { id: "fr", name: "Marketlens FR",  url: "marketlens.fr",       flag: "🇫🇷", lang: "French" },
    { id: "es", name: "Marketlens ES",  url: "marketlens.es",       flag: "🇪🇸", lang: "Spanish", over: true },
  ];

  // Map nav id -> { title, subtitle, stage } for headers + stub copy.
  const SCREEN_META = {
    posts: { title: "Posts", sub: "Draft, review and publish posts across the active site. Every save lands in Draft until you explicitly publish." },
    pages: { title: "Pages", sub: "Static pages and their publish state.", stage: 6 },
    categories: { title: "Categories", sub: "Taxonomy management for the active site.", stage: 6 },
    tags: { title: "Tags", sub: "Tag taxonomy management.", stage: 6 },
    "taxonomy-suggestions": { title: "Taxonomy Library", sub: "AI suggests categories and tags from your content, approved keywords and research topics. Approve to create them in WordPress." },
    "taxonomy-audit": { title: "Taxonomy Audit", sub: "Scan posts and apply missing categories & tags from your existing and approved terms." },
    reports: { title: "Reports", sub: "Assembled read-only report: performance, pipeline, SEO health, competitors, to-dos.", stage: 10 },
    "seo-dashboard": { title: "SEO Dashboard", sub: "Site-wide SEO health at a glance.", stage: 9 },
    performance: { title: "Performance", sub: "Google Search Console - clicks, impressions, CTR and position over time.", stage: 9 },
    "site-audit": { title: "Site Audit", sub: "Technical and on-page issues by severity.", stage: 9 },
    "page-inventory": { title: "Page Inventory", sub: "Every public page the crawler found on this site, with the title, description and status it served." },
    "bulk-meta": { title: "Bulk Meta Editor", sub: "Inline-edit titles and meta descriptions across many URLs.", stage: 9 },
    "internal-linking": { title: "Internal Linking", sub: "AI-suggested internal links between your content.", stage: 9 },
    "content-planner": { title: "Content Planner", sub: "Plan board / calendar for upcoming content.", stage: 8 },
    "keywords-planner": { title: "Keywords Planner", sub: "Keyword library with intent, priority and cluster classification.", stage: 8 },
    "topics-bank": { title: "Topics Bank", sub: "Reusable topic clusters mined from research.", stage: 8 },
    "coverage-map": { title: "Coverage Map", sub: "Which categories and tags have content behind them, and which are only names." },
    "industry-analysis": { title: "Industry Analysis", sub: "Run an AI analysis against a BI industry entity.", stage: 8 },
    "competitors-analysis": { title: "Competitors Analysis", sub: "Gaps-vs-us, keyword overlap and content opportunities.", stage: 8 },
    "partners-analysis": { title: "Partners Analysis", sub: "Complementary topics and co-marketing angles.", stage: 8 },
    "product-enrichment": { title: "Product Enrichment", sub: "Enrich product offerings with AI-gathered detail.", stage: 8 },
    inbox: { title: "Inbox", sub: "Capture research by pasting text or fetching a URL, then summarise into a draft.", stage: 10 },
    todo: { title: "To-do", sub: "Research and content tasks across their states.", stage: 10 },
    "business-profile": { title: "Business Profile", sub: "The single owner-entity setup and Market constraint.", stage: 7 },
    products: { title: "Products", sub: "Offerings with multiple providers, coverage gaps and nested variants.", stage: 7 },
    "bi-competitors": { title: "Competitors", sub: "BI module - your tracked competitor entities.", stage: 7 },
    "bi-industry": { title: "Industry", sub: "BI module - industry entities and segments.", stage: 7 },
    "bi-partners": { title: "Partners", sub: "BI module - partner and complementary entities.", stage: 7 },
    "ai-assistant": { title: "AI Assistant", sub: "Content-strategy chat grounded in your BI graph.", stage: 10 },
  };

  // Sample posts for the inhabited Posts list (draft-first content).

  window.MlData = { NAV_GROUPS, SITES, SCREEN_META };
})();
